module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jianlu-live-wrap",
    style: ({
      background: _vm.row.show_bg || '#000'
    })
  }, [_c('div', {
    staticClass: "machine-head",
    style: ({
      color: _vm.row.show_font_color
    })
  }, [_c('img', {
    staticClass: "jianlu-live-logo jianlu-live-logo--left",
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1775121359591-20.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.saiqu.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('img', {
    staticClass: "jianlu-live-logo jianlu-live-logo--right",
    attrs: {
      "src": "https://wa.ccachina.net/img/logo.58b57af4.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('iframe', {
    staticClass: "jianlu-live-iframe",
    attrs: {
      "src": _vm.liveUrl,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-508cf600","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/score/ScoreJianluLive.vue
// module id = 2394
// module chunks = 0